// React&NextJS
import { useState } from 'react'
// 3rd party libraries
// import algoliasearch from 'algoliasearch'
// import { InstantSearch, Hits, Configure } from 'react-instantsearch-dom'
import 'instantsearch.css/themes/reset.css'
// Types
// import { Service } from '../types/types'
// Styles
import s from '../styles/pages/Services.module.scss'
// Components
import { Container } from '../components/core/container/Container'
import { Filters } from '../components/core/filters/Filters'
import Meta from '../components/meta/Meta'
import { Section } from '../components/core/section/Section'
// import ServiceCard from '../components/cards/serviceCard/ServiceCard'
import { Text } from '../components/core/text/Text'
import { ServiceCardVariable } from '../components/cards/serviceCardVariable/ServiceCardVariable'
import { Image } from '../components/core/image/Image'

// const client = algoliasearch('U7FELI92RY', '16c6f148489642a701df11de2aec8b3d')

// function Hit({ hit }) {
//     const service: Service = hit

//     return <ServiceCard service={service} />
// }

const serviceCards = [
    <ServiceCardVariable
        service={{
            title: 'Frímann & Hálfdán - Útfararþjónusta',
            description: 'Útfararþjónusta Hafnarfjarðar',
            region: [],
            type: 'Hafnarfjörður',
            logo: 'https://firebasestorage.googleapis.com/v0/b/minning-f44b2.appspot.com/o/services%2Futfarathonusta-halfdan%2Fhalfdan.jfif?alt=media&token=35201ac5-b638-4188-9a95-d47b820bea71',
            text: 'Hér mun standa texti um hvað er boðið upp á hjá hverjum þjónustuaðila fyrir sig. Þjónustusíða Minningar.is munu sýna breitt úrval slíkra aðila um allt land, flokkað eftir tegund þjónustu. Hafðu samband á minningar@minningar.is',
            mobile: '565-9775',
            email: 'uth@uth.is',
            location: 'Stapahraun 5, Hafnarfirði',
            website: 'uth.is',
        }}
        key={1}
    >
        <div className={s.variable}>
            {/* <Text variant="p-small">{service.text}</Text> */}
            <div className={s.image_text}>
                <Image src="https://firebasestorage.googleapis.com/v0/b/minning-f44b2.appspot.com/o/services%2Futfarathonusta-halfdan%2Futfararthjonusta-frimann-600x721.jpg?alt=media&" />
                <Text variant="p">Frímann Andrésson</Text>
            </div>
            <div className={s.image_text}>
                <Image src="https://firebasestorage.googleapis.com/v0/b/minning-f44b2.appspot.com/o/services%2Futfarathonusta-halfdan%2Futfararthjonusta-halfdan-600x721.jpg?alt=media&" />
                <Text variant="p">Hálfdán Hálfdánarson</Text>
            </div>
            <div className={s.image_text}>
                <Image src="https://firebasestorage.googleapis.com/v0/b/minning-f44b2.appspot.com/o/services%2Futfarathonusta-halfdan%2Futfararthjonusta-olof-600x721.jpg?alt=media&" />
                <Text variant="p">Ólöf Helgadóttir</Text>
            </div>
            {/* <div className={s.image_text}>
                <Image src="https://firebasestorage.googleapis.com/v0/b/minning-f44b2.appspot.com/o/services%2Futfarastofa-islands%2Fj%C3%B3n-200x300.png?alt=media&token=7cefbdc1-4f8f-4398-adcc-abfe220b430a" />
                <Text variant="p">Jón G. Bjarnason</Text>
            </div> */}
            {/* <div className={s.image_text}>
                <Image src="https://firebasestorage.googleapis.com/v0/b/minning-f44b2.appspot.com/o/services%2Futfarathonusta-halfdan%2Futfararthjonusta-kristin-600x721.jpg?alt=media&" />

                <Text variant="p">Kristín Margrét Ingólfsdóttir</Text>
            </div> */}
        </div>
    </ServiceCardVariable>,

    // <ServiceCardVariable
    //     service={{
    //         title: 'Útfararstofa Svafars og Hermanns',
    //         region: [],
    //         type: 'Reykjavík',
    //         logo: 'https://firebasestorage.googleapis.com/v0/b/minning-f44b2.appspot.com/o/services%2Futfarathonusta-svafars%2Futfor-svafar.png?alt=media&token=e8f181ce-c1fa-4b99-b792-cc123d587598',
    //         mobile: '571-8222',
    //         email: 'kvedja@kvedja.is',
    //         location: 'Síðumúla 28, 108 Reykjavík',
    //         website: 'kvedja.is',
    //     }}
    //     key={2}
    // >
    //     <div className={s.variable}>
    //         {/* <Text variant="p-small">{service.text}</Text> */}
    //         <div className={s.image_text}>
    //             <Image src="https://firebasestorage.googleapis.com/v0/b/minning-f44b2.appspot.com/o/services%2Futfarathonusta-svafars%2Fsvafar2.jpg?alt=media&token=5826cb64-df29-4e07-baeb-caabafcc4c4d" />
    //             <Text variant="p">Svafar Magnússon</Text>
    //         </div>
    //         <div className={s.image_text}>
    //             <Image src="https://firebasestorage.googleapis.com/v0/b/minning-f44b2.appspot.com/o/services%2Futfarathonusta-svafars%2Fhermann2.jpg?alt=media&token=28cbbad0-df9d-4820-bb37-ee92b94d866f" />
    //             <Text variant="p">Hermann Jónasson</Text>
    //         </div>
    //     </div>
    // </ServiceCardVariable>,
    // <ServiceCardVariable
    //     service={{
    //         title: 'Útfararstofa Kirkjugarðanna Fossvogi',
    //         location: 'Vesturhlíð 2, 105 Reykjavík',
    //         type: 'Reykjavík',
    //         email: 'utfor@utfor.is',
    //         mobile: '551-1266',
    //         website: 'utfor.is',
    //         logo: 'https://firebasestorage.googleapis.com/v0/b/minning-f44b2.appspot.com/o/services%2Futfarastofa-fossvogi%2Futfor-foss.png?alt=media&token=a1dde2ab-5190-4f00-ac86-7cb50d1198ac',
    //     }}
    //     key={3}
    // >
    //     <div className={s.variable}>
    //         {/* <Text variant="p-small">{service.text}</Text> */}
    //         <div className={s.image_text}>
    //             <Image
    //                 height={125}
    //                 width={125}
    //                 centerFace={true}
    //                 src="https://firebasestorage.googleapis.com/v0/b/minning-f44b2.appspot.com/o/services%2Futfarastofa-fossvogi%2FEllert-inga.jpg?alt=media&token=66dc8a26-a4c4-4929-af0c-0ce93e0e3d2b"
    //             />
    //             <Text variant="p">Ellert Ingason</Text>
    //         </div>
    //         <div className={s.image_text}>
    //             <Image
    //                 height={125}
    //                 width={125}
    //                 centerFace={true}
    //                 src="https://firebasestorage.googleapis.com/v0/b/minning-f44b2.appspot.com/o/services%2Futfarastofa-fossvogi%2Femilia.jpg?alt=media&token=4832d68c-62b6-409e-a1c8-5d46df0f5605"
    //             />
    //             <Text variant="p">Emilía Jónsdóttir</Text>
    //         </div>
    //         <div className={s.image_text}>
    //             <Image
    //                 height={125}
    //                 width={125}
    //                 centerFace={true}
    //                 src="https://firebasestorage.googleapis.com/v0/b/minning-f44b2.appspot.com/o/services%2Futfarastofa-fossvogi%2Fgudmundur1.png?alt=media&token=dfe9a094-0758-44e8-bd4c-9117ff455243"
    //             />
    //             <Text variant="p">Guðmundur Baldvinsson</Text>
    //         </div>
    //         <div className={s.image_text}>
    //             <Image
    //                 height={125}
    //                 width={125}
    //                 centerFace={true}
    //                 src="https://firebasestorage.googleapis.com/v0/b/minning-f44b2.appspot.com/o/services%2Futfarastofa-fossvogi%2Fsepia_gudny_bw_crop_01.jpg?alt=media&token=9279ac92-3cd1-41ff-b426-a462af7c34ec"
    //             />
    //             <Text variant="p">Guðný Hildur Kristinsdóttir</Text>
    //         </div>
    //         <div className={s.image_text}>
    //             <Image
    //                 height={125}
    //                 width={125}
    //                 centerFace={true}
    //                 src="https://firebasestorage.googleapis.com/v0/b/minning-f44b2.appspot.com/o/services%2Futfarastofa-fossvogi%2Fhelga-mynd-300_300.png?alt=media&token=be51fe7e-374f-45f0-a35f-a60ad58ade30"
    //             />
    //             <Text variant="p">Helga Guðmundsdóttir</Text>
    //         </div>
    //         <div className={s.image_text}>
    //             <Image
    //                 height={125}
    //                 width={125}
    //                 centerFace={true}
    //                 src="https://firebasestorage.googleapis.com/v0/b/minning-f44b2.appspot.com/o/services%2Futfarastofa-fossvogi%2Fhinrik-svarthvitt.jpg?alt=media&token=c8b51aa0-a12f-41f0-a96b-e7870a1db5b4"
    //             />
    //             <Text variant="p">Hinrik Valsson</Text>
    //         </div>
    //         <div className={s.image_text}>
    //             <Image
    //                 height={125}
    //                 width={125}
    //                 centerFace={true}
    //                 src="https://firebasestorage.googleapis.com/v0/b/minning-f44b2.appspot.com/o/services%2Futfarastofa-fossvogi%2Flara.jpg?alt=media&token=da277c4d-d011-4fb5-ab40-f25b6d6337b8"
    //             />
    //             <Text variant="p">Lára Árnadóttir</Text>
    //         </div>
    //         <div className={s.image_text}>
    //             <Image
    //                 height={125}
    //                 width={125}
    //                 centerFace={true}
    //                 src="https://firebasestorage.googleapis.com/v0/b/minning-f44b2.appspot.com/o/services%2Futfarastofa-fossvogi%2Fmagnus.jpg?alt=media&token=84f9adaa-287e-4088-a4e1-081c21f0a038"
    //             />
    //             <Text variant="p">Magnús Sævar Magnússon</Text>
    //         </div>
    //     </div>
    // </ServiceCardVariable>,
    <ServiceCardVariable
        service={{
            title: 'Útfararstofa Reykjavíkur',
            type: 'Reykjavík',
            location: 'Álfheimum 35, 104 Reykjavík',
            email: 'isleifur@usr.is',
            mobile: '553-5353',
            website: 'usr.is',
            logo: 'https://firebasestorage.googleapis.com/v0/b/minning-f44b2.appspot.com/o/services%2Futfarastofa-reykjavikur%2Fusr-logo-staerra-e1462899616365.png?alt=media&token=d1e5d54d-b7c1-4415-90d4-658051c64269',
        }}
        key={4}
    >
        <div className={s.variable}>
            {/* <Text variant="p-small">{service.text}</Text> */}
            <div className={s.image_text}>
                <Image src="https://firebasestorage.googleapis.com/v0/b/minning-f44b2.appspot.com/o/services%2Futfarastofa-reykjavikur%2Fisleifur-jonsson.jpg?alt=media&token=46d0c0a3-7e93-4b51-965e-3e198615c558" />
                <Text variant="p">Ísleifur Jónsson</Text>
            </div>
            <div className={s.image_text}>
                <Image src="https://firebasestorage.googleapis.com/v0/b/minning-f44b2.appspot.com/o/services%2Futfarastofa-reykjavikur%2FSteinunn.jpg?alt=media&token=f233ece8-067c-4bf2-a618-aa30d0516d9f" />
                <Text variant="p">Steinunn</Text>
            </div>
        </div>
    </ServiceCardVariable>,
    // <ServiceCardVariable
    //     service={{
    //         title: 'Útfararþjónusta Rúnars Geirmundssonar',
    //         location: 'Þverholti 30, 105 Reykjavík',
    //         type: 'Reykjavík',

    //         email: 'utfarir@utfarir.is',
    //         mobile: '567-9110',
    //         website: 'utfarir.is',
    //         logo: 'https://firebasestorage.googleapis.com/v0/b/minning-f44b2.appspot.com/o/services%2Futfarathonusta-runars%2Frg-logo.png?alt=media&token=fab1995e-f3f0-4f99-8762-37ea28ec3a3f',
    //     }}
    //     key={5}
    // >
    //     <div className={s.variable}>
    //         {/* <Text variant="p-small">{service.text}</Text> */}
    //         <div className={s.image_text}>
    //             <Image src="https://firebasestorage.googleapis.com/v0/b/minning-f44b2.appspot.com/o/services%2Futfarathonusta-runars%2Frunar-geirmundsson.jpg?alt=media&token=ef06717f-2f8b-45cb-bc0b-ab198d2c383e" />
    //             <Text variant="p">Rúnar Geirmundsson</Text>
    //         </div>
    //         <div className={s.image_text}>
    //             <Image src="https://firebasestorage.googleapis.com/v0/b/minning-f44b2.appspot.com/o/services%2Futfarathonusta-runars%2Felis-mynd.jpg?alt=media&token=81daa1c7-fcf2-4d89-8267-d2e6205329f5" />
    //             <Text variant="p">Elís Rúnarsson</Text>
    //         </div>
    //         <div className={s.image_text}>
    //             <Image src="https://firebasestorage.googleapis.com/v0/b/minning-f44b2.appspot.com/o/services%2Futfarathonusta-runars%2Fmynd-sigurdur-runarsson.jpg?alt=media&token=42113029-f9ac-4d44-852b-aa197f02d8f5" />
    //             <Text variant="p">Sigurður Rúnarsson</Text>
    //         </div>
    //     </div>
    // </ServiceCardVariable>,
    <ServiceCardVariable
        service={{
            title: 'Útfararstofa Íslands',
            location: 'Auðbrekku 1, 200 Kópavogi',
            type: 'Kópavogur',
            email: 'utforin@utforin.is',
            mobile: '581-3300',
            website: 'utforin.is',
            logo: 'https://firebasestorage.googleapis.com/v0/b/minning-f44b2.appspot.com/o/services%2Futfarastofa-islands%2Futf-isl.png?alt=media&token=b187f493-bdc8-4140-adf8-42b7e76bec26',
        }}
        key={6}
    >
        <div className={s.variable}>
            {/* <Text variant="p-small">{service.text}</Text> */}
            <div className={s.image_text}>
                <Image src="https://firebasestorage.googleapis.com/v0/b/minning-f44b2.appspot.com/o/services%2Futfarastofa-islands%2Fsverr.jpg?alt=media&token=eedd2e21-37a8-40e9-a03f-7b379122cb2f" />
                <Text variant="p">Sverrir Einarsson</Text>
            </div>
            {/* <div className={s.image_text}>
                <Image src="https://firebasestorage.googleapis.com/v0/b/minning-f44b2.appspot.com/o/services%2Futfarastofa-islands%2Fj%C3%B3n-200x300.png?alt=media&token=7cefbdc1-4f8f-4398-adcc-abfe220b430a" />
                <Text variant="p">Jón G. Bjarnason</Text>
            </div> */}
            <div className={s.image_text}>
                <Image src="https://firebasestorage.googleapis.com/v0/b/minning-f44b2.appspot.com/o/services%2Futfarastofa-islands%2Fj%C3%B3hanna-200x300.png?alt=media&token=ebb4f742-dde3-4bfa-a39e-42976cb8193d" />
                <Text variant="p">Jóhanna Eiríksdóttir</Text>
            </div>
        </div>
    </ServiceCardVariable>,
    <ServiceCardVariable
        service={{
            title: 'Útfararstofa Hafnafjarðar',
            location: 'Dofrahella 9b, 221 Hafnarfirði',
            type: 'Hafnarfjörður',
            email: 'utforin@utforin.is',
            mobile: '565-5892',
            website: 'utfararstofa.is',
            logo: 'https://firebasestorage.googleapis.com/v0/b/minning-f44b2.appspot.com/o/services%2Futfarastofa-islands%2F278007815_548750343240013_8072358056648391906_n.png?alt=media&token=7bdb7f91-9f07-4049-ac1d-9c692d7505d1',
        }}
        key={61}
    >
        <div className={s.variable}>
            {/* <Text variant="p-small">{service.text}</Text> */}
            <div className={s.image_text}>
                <Image src="https://firebasestorage.googleapis.com/v0/b/minning-f44b2.appspot.com/o/services%2Futfarastofa-islands%2Fsverr.jpg?alt=media&token=eedd2e21-37a8-40e9-a03f-7b379122cb2f" />
                <Text variant="p">Sverrir Einarsson</Text>
            </div>
            {/* <div className={s.image_text}>
                <Image src="https://firebasestorage.googleapis.com/v0/b/minning-f44b2.appspot.com/o/services%2Futfarastofa-islands%2Fj%C3%B3n-200x300.png?alt=media&token=7cefbdc1-4f8f-4398-adcc-abfe220b430a" />
                <Text variant="p">Jón G. Bjarnason</Text>
            </div> */}
            <div className={s.image_text}>
                <Image src="https://firebasestorage.googleapis.com/v0/b/minning-f44b2.appspot.com/o/services%2Futfarastofa-islands%2Fj%C3%B3hanna-200x300.png?alt=media&token=ebb4f742-dde3-4bfa-a39e-42976cb8193d" />
                <Text variant="p">Jóhanna Eiríksdóttir</Text>
            </div>
        </div>
    </ServiceCardVariable>,
    // <ServiceCardVariable
    //     service={{
    //         title: 'Útfararþjónusta Davíðs Ósvaldssonar ehf',
    //         location: 'Dalsbyggð 15, 210 Garðabæ',
    //         type: 'Garðabær',

    //         email: 'osvaldutfor@gmail.com',
    //         mobile: '551-3485',
    //         website: '',
    //         logo: '',
    //     }}
    //     key={7}
    // >
    //     <div className={s.variable}></div>
    // </ServiceCardVariable>,
    <ServiceCardVariable
        service={{
            title: 'Harpa útfararstofa',
            location: 'Kirkjulundi 19, 210 Garðabæ',
            type: 'Garðabær',
            email: 'harpa@harpautfor.is',
            mobile: '842-0204',
            mobile2: '821-2045',
            website: 'harpautfor.is',
            logo: 'https://firebasestorage.googleapis.com/v0/b/minning-f44b2.appspot.com/o/services%2Futfarastofa-harpa%2Fharpa.png?alt=media&token=79039492-ec3e-4d9c-b716-98173280af12',
        }}
        key={8}
    >
        <div className={s.variable}>
            {/* <Text variant="p-small">{service.text}</Text> */}
            <div className={s.image_text}>
                <Image src="https://firebasestorage.googleapis.com/v0/b/minning-f44b2.appspot.com/o/services%2Futfarastofa-harpa%2FHarpa-of-color.jpg?alt=media&token=d71b94b9-94ec-445d-ba34-17b484583427" />
                <Text variant="p">Harpa Heimisdóttir</Text>
            </div>
            <div className={s.image_text}>
                <Image src="https://firebasestorage.googleapis.com/v0/b/minning-f44b2.appspot.com/o/services%2Futfarastofa-harpa%2FBrynja-of-color.jpg?alt=media&token=b483c486-0b28-4398-a0c8-2139821ba569" />
                <Text variant="p">Brynja Gunnarsdóttir</Text>
            </div>
        </div>
    </ServiceCardVariable>,
    <ServiceCardVariable
        service={{
            title: 'Útfararþjónusta Suðurnesja',
            location: 'Vesturbraut 8, 230 Reykjanesbæ',
            type: 'Reykjanesbær',

            email: 'utfararthjonusta@simnet.is',
            mobile: '421-5333',
            website: 'utfararthjonusta.is',
            logo: 'https://firebasestorage.googleapis.com/v0/b/minning-f44b2.appspot.com/o/services%2Futfarathjonusta-sudurnesja%2Futfsudurnes.png?alt=media&token=14f799ef-32d8-4cf0-b63d-762c2fdea9fe',
        }}
        key={10}
    >
        <div className={s.variable}>
            {/* <Text variant="p-small">{service.text}</Text> */}
            <div className={s.image_text}>
                <Image src="https://firebasestorage.googleapis.com/v0/b/minning-f44b2.appspot.com/o/services%2Futfarathjonusta-sudurnesja%2FKristin.jpg?alt=media&token=4d716c55-6384-43d1-8558-acf3761abdea" />
                <Text variant="p">Kristín Richardsdóttir</Text>
            </div>
            <div className={s.image_text}>
                <Image src="https://firebasestorage.googleapis.com/v0/b/minning-f44b2.appspot.com/o/services%2Futfarathjonusta-sudurnesja%2FAdalsteinn.jpg?alt=media&token=493a896c-4eb4-4e36-b1eb-5a40a4114607" />
                <Text variant="p">Aðalsteinn H. Jónatansson</Text>
            </div>
            <div className={s.image_text}>
                <Image src="https://firebasestorage.googleapis.com/v0/b/minning-f44b2.appspot.com/o/services%2Futfarathjonusta-sudurnesja%2FHeidur.jpg?alt=media&token=44283f4a-4b60-4f41-a1d9-64372b3c8f40" />
                <Text variant="p">Heiður Huld Fríðriksdóttir</Text>
            </div>
        </div>
    </ServiceCardVariable>,
    <ServiceCardVariable
        service={{
            title: 'Borg útfararþjónusta',
            location: 'Stekkjarholti 2, 310 Borgarnesi',
            type: 'Borgarnes',
            email: 'borg@borgutfor.is',
            mobile: '869-7522',
            mobile2: '770-0188',
            website: 'borgutfor.is',
            logo: 'https://firebasestorage.googleapis.com/v0/b/minning-f44b2.appspot.com/o/services%2Futfararthjonusta-borg%2FborgLogo.webp?alt=media&token=d8c14d6c-fea8-4c8f-9092-2af8b2a3da90',
        }}
        key={11}
    >
        <div className={s.variable}>
            {/* <Text variant="p-small">{service.text}</Text> */}
            <div className={s.image_text}>
                <Image src="https://firebasestorage.googleapis.com/v0/b/minning-f44b2.appspot.com/o/services%2Futfararthjonusta-borg%2FGudny.webp?alt=media&token=aca7057c-60ed-4ddd-9431-68ed17c24a64" />
                <Text variant="p">Guðný Bjarnadóttir</Text>
            </div>
            <div className={s.image_text}>
                <Image src="https://firebasestorage.googleapis.com/v0/b/minning-f44b2.appspot.com/o/services%2Futfararthjonusta-borg%2Fgreta.webp?alt=media&token=993c3ede-53c8-4134-9dcd-1fb6a0327784" />
                <Text variant="p">Gréta Björgvinsdóttir</Text>
            </div>
        </div>
    </ServiceCardVariable>,
    <ServiceCardVariable
        service={{
            title: 'Útfararþjónustan Fylgd',
            location: 'Gagnheiði 43, 800 Selfossi',
            type: 'Selfoss',
            email: 'fylgd@fylgd.is',
            mobile: '482-4300',
            website: 'fylgd.is',
            logo: 'https://firebasestorage.googleapis.com/v0/b/minning-f44b2.appspot.com/o/services%2Futfararthjonusta-fylgd%2Ffylgd.png?alt=media&token=98b985b4-4cbb-42a8-9020-4ae5e230819b',
        }}
        key={12}
    >
        <div className={s.variable}>
            {/* <Text variant="p-small">{service.text}</Text> */}
            <div className={s.image_text}>
                <Image
                    height={190}
                    width={130}
                    src="https://firebasestorage.googleapis.com/v0/b/minning-f44b2.appspot.com/o/services%2Futfararthjonusta-fylgd%2FGisli.jpg?alt=media&token=2e255316-fcf8-412b-afdf-99778448918e"
                />
                <Text variant="p">Gísli Gunnar Guðmundsson</Text>
            </div>
            <div className={s.image_text}>
                <Image
                    height={190}
                    width={130}
                    src="https://firebasestorage.googleapis.com/v0/b/minning-f44b2.appspot.com/o/services%2Futfararthjonusta-fylgd%2FSvanhildur.jpg?alt=media&token=4447d2c9-a0a2-448f-822e-d813be79adca"
                />
                <Text variant="p">Svanhildur Eiríksdóttir</Text>
            </div>
            <div className={s.image_text}>
                <Image
                    height={190}
                    width={130}
                    src="https://firebasestorage.googleapis.com/v0/b/minning-f44b2.appspot.com/o/services%2Futfararthjonusta-fylgd%2FElfar.jpg?alt=media&token=f95d4dfa-1007-4e45-836e-4f7de5cf6270"
                />
                <Text variant="p">Elfar Freyr Sigurjónsson</Text>
            </div>
        </div>
    </ServiceCardVariable>,
    <ServiceCardVariable
        service={{
            title: 'Útfararþjónustan Sólsetur',
            location: 'Ártúni 1, 850 Hellu',
            type: 'Hella',
            email: 'solseturhellu@gmail.com',
            mobile: '860-2802',
            website: '',
        }}
        key={13}
    >
        <div className={s.variable}></div>
    </ServiceCardVariable>,
    // <ServiceCardVariable
    //     service={{
    //         title: 'HS bílar ehf hópferða- og útfararþjónusta',
    //         location: 'Þvervegi 6, 340 Stykkishólmi',
    //         type: 'Stykkishólmur',
    //         email: '',
    //         mobile: '893-9782',
    //         website: '',
    //     }}
    //     key={14}
    // >
    //     <div className={s.variable}></div>
    // </ServiceCardVariable>,
    <ServiceCardVariable
        service={{
            title: 'Útfararþjónusta Borgarfjarðar og Stranda',
            type: [
                'Hólmavík',
                'Borgarnes',
                'Búðardalur',
                'Reykhólar',
                'Akureyri',
            ],
            email: 'jardarforin@jardarforin.is',
            mobile: '896-4703',

            website: 'jardarforin.is',
            logo: 'https://firebasestorage.googleapis.com/v0/b/minning-f44b2.appspot.com/o/services%2Futfarar%C3%BEjonusta-borgarfjardar-og-stranda%2Fjardaforin-logo.png?alt=media&token=29e0f6a1-ba1b-43cd-9cb9-ed8b6362e90c',
        }}
        key={15}
    >
        <div className={s.variable}>
            <div className={s.image_text}>
                <Image
                    height={190}
                    width={130}
                    src="https://firebasestorage.googleapis.com/v0/b/minning-f44b2.appspot.com/o/services%2Futfarar%C3%BEjonusta-borgarfjardar-og-stranda%2Fvidar-gudmundsson.jpg?alt=media&token=fe2c87b3-e24b-4abe-91f9-1d3cbab5ed26"
                />
                <Text variant="p">Viðar Guðmundsson</Text>
            </div>
            <div className={s.image_text}>
                <Image
                    height={190}
                    width={130}
                    src="https://firebasestorage.googleapis.com/v0/b/minning-f44b2.appspot.com/o/services%2Futfarar%C3%BEjonusta-borgarfjardar-og-stranda%2Finga-sigurdar.jpg?alt=media&token=b53168aa-6ff2-4c93-87b1-f143506a6a35"
                />
                <Text variant="p">Inga Sigurðardóttir</Text>
            </div>
            <div className={s.image_text}>
                <Image
                    height={190}
                    width={130}
                    src="https://firebasestorage.googleapis.com/v0/b/minning-f44b2.appspot.com/o/services%2Futfarar%C3%BEjonusta-borgarfjardar-og-stranda%2Ftorhildur-torsteinsdottir.jpg?alt=media&token=e2492f28-1da9-4766-8108-76f48646ef15"
                />
                <Text variant="p">Þórhildur Þorsteinsdóttir</Text>
            </div>
            <div className={s.image_text}>
                <Image
                    height={190}
                    width={130}
                    src="https://firebasestorage.googleapis.com/v0/b/minning-f44b2.appspot.com/o/services%2Futfarar%C3%BEjonusta-borgarfjardar-og-stranda%2Felvar-olason.jpg?alt=media&token=a8a81423-2199-4b2e-a3b0-37e231130331"
                />
                <Text variant="p">Elvar Ólason</Text>
            </div>
            <div className={s.image_text}>
                <Image
                    height={190}
                    width={130}
                    src="https://firebasestorage.googleapis.com/v0/b/minning-f44b2.appspot.com/o/services%2Futfarar%C3%BEjonusta-borgarfjardar-og-stranda%2Fbarbara-osk-gudbjartsdottir.jpg?alt=media&token=cdc8e391-2c8d-4809-9ad8-ec5ee3a15c74"
                />
                <Text variant="p">Barbara Ósk Guðbjartsdóttir</Text>
            </div>
        </div>
    </ServiceCardVariable>,
    <ServiceCardVariable
        service={{
            title: 'Hugsjón útfararþjónusta',
            location: 'Bogabraut 14, 545 Skagaströnd',
            type: 'Skagaströnd',
            email: 'hugsjonutfor@gmail.com',
            mobile: '868-4925',
            website: 'hugsjonutfor.is',
            logo: 'https://firebasestorage.googleapis.com/v0/b/minning-f44b2.appspot.com/o/services%2Fhugsjon-utfararthjonusta%2F146144902_202070381615281_2814192685741535562_n.jpg?alt=media&token=6bfcfd2c-49f8-4cb7-b27a-2e3b01716805',
        }}
        key={16}
    >
        <div className={s.variable}>
            <div className={s.image_text}>
                <Image
                    height={190}
                    width={130}
                    src="https://firebasestorage.googleapis.com/v0/b/minning-f44b2.appspot.com/o/services%2Fhugsjon-utfararthjonusta%2Fhugrun.webp?alt=media&token=3d74d248-10b3-450b-abd1-6973cad2696a"
                />
                <Text variant="p">Hugrún Sif Hallgrímsdóttir</Text>
            </div>
            <div className={s.image_text}>
                <Image
                    height={190}
                    width={130}
                    src="https://firebasestorage.googleapis.com/v0/b/minning-f44b2.appspot.com/o/services%2Fhugsjon-utfararthjonusta%2Fjon.webp?alt=media&token=8c48f6ea-b753-44e7-9d4e-87af31052890"
                />
                <Text variant="p">Jón Ólafur Sigurjónsson</Text>
            </div>
        </div>
    </ServiceCardVariable>,
    <ServiceCardVariable
        service={{
            title: 'Útfararþjónusta kirkjugarða Akureyrar',
            location: 'Höfðagötu 1, 600 Akureyri',
            type: 'Akureyri',
            email: 'utfarir@kirkjugardur.is',
            mobile: '461-4060',
            website: 'kirkjugardur.is/utka',
        }}
        key={17}
    >
        <div className={s.variable}></div>
    </ServiceCardVariable>,
]

const SudVest = [
    'Reykjavík',
    'Kópavogur',
    'Hafnarfjörður',
    'Garðabær',
    'Reykjanesbær',
    'Borgarnes',
]

const Sud = ['Selfoss', 'Hella']

const Aus = []

const Nor = ['Akureyri', 'Skagaströnd']

const Ves = ['Búðardalur', 'Akranes', 'Borgarnes']

const Vestf = ['Hólmavík', 'Reykhólar']

export default function Services() {
    const [filterIndex, setFilterIndex] = useState(-1)
    const [type, setType] = useState('')
    // const [, setRegion] = useState('')

    console.log('how long', serviceCards.length)

    const typeFilter = (s: string, i: number) => {
        // if filter field is selected replace chars and set type for Algolia
        if (i !== -1) {
            const f = s

            setFilterIndex(i)
            setType(f)
        }
        // show all services from algolia
        else {
            setFilterIndex(i)
            setType('')
        }
    }

    const shuffleCards = (cardList: JSX.Element[]) => {
        let currentIndex = cardList.length

        // While there remain elements to shuffle...
        while (currentIndex != 0) {
            // Pick a remaining element...
            const randomIndex = Math.floor(Math.random() * currentIndex)
            currentIndex--

            // And swap it with the current element.
            ;[cardList[currentIndex], cardList[randomIndex]] = [
                cardList[randomIndex],
                cardList[currentIndex],
            ]
        }

        return cardList
    }

    const servi = shuffleCards(
        serviceCards.filter((i) => {
            const t = i.props.service.type as string | string[]

            // No filter: show everything
            if (type === '') return true

            // Helper that checks region buckets
            const inBucket = (val: string) => {
                if (type === 'Suður- og Vesturland')
                    return SudVest.includes(val)
                if (type === 'Suðurland') return Sud.includes(val)
                if (type === 'Austurland') return Aus.includes(val)
                if (type === 'Norðurland') return Nor.includes(val)
                if (type === 'Vesturland') return Ves.includes(val)
                if (type === 'Vestfirðir') return Vestf.includes(val)
                return false
            }

            if (Array.isArray(t)) {
                // Any match in the array passes
                return t.some((val) => val === type || inBucket(val))
            } else {
                // t is a string
                return t === type || inBucket(t)
            }
        })
    )

    console.log('servi', servi.length)

    return (
        <>
            <Meta
                title="Minningar - Þjónustusíða"
                seoTitle="Minningar - Þjónustusíða"
                description="Allar helstu þjónustur sem tengjast útförum."
                url="https://minningar.is/services"
                image="https://ik.imagekit.io/minningar/Seo/Services_hhyjNkBbG?ik-sdk-version=javascript-1.4.3&updatedAt=1649846782601&tr=w-1200%2Ch-630%2Cfo-auto"
                type="website"
            />
            <Section>
                <Container className={s.header}>
                    <Text
                        variant="h1"
                        align="center"
                        className={s.header__item}
                    >
                        Þjónustusíða
                    </Text>
                    <Text
                        variant="p-18"
                        align="center"
                        className={s.header__item}
                    >
                        Á þjónustusíðu Minningar.is má finna flestar
                        útfararþjónustur landsins. Á næstunni munu einnig bætast
                        við fleiri tegundir þjónustuaðila, s.s. veisluþjónustur
                        og blómabúðir.
                    </Text>
                </Container>
                <Container className={s.container}>
                    <div className={s.filters}>
                        <Filters
                            filterNames={[
                                'Suðurland',
                                'Suður- og Vesturland',
                                'Vesturland',
                                'Vestfirðir',
                                'Norðurland',
                                'Austurland',
                            ]}
                            typeFilter={typeFilter}
                            setState={setFilterIndex}
                            selectedIndex={filterIndex}
                        />
                        {/* <select
                            name="region"
                            id="region"
                            onChange={(e) => {
                                setRegion(e.target.value)
                            }}
                        >
                            <option hidden>Veldu landshluta</option>
                            <option value="austurland">Austurland</option>
                            <option value="hofudborgarsvaedi">
                                Höfuðborgarsvæði
                            </option>
                            <option value="sudurland">Suðurland</option>
                            <option value="sudurnes">Suðurnes</option>
                            <option value="nordurland">Norðurland</option>
                            <option value="">Öllu landinu</option>
                        </select> */}
                    </div>
                    <div className={s.content}>{servi}</div>
                </Container>
            </Section>
        </>
    )
}
